import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/* Just a template root here
 * This file is the source entry.
 */
import { getAllUTMProps, getAllUTMParamNames } from './utils/utm';
export { base64Encode, base64Decode } from './utils/string';
export { getQueryParams } from './utils/url';
export { getAllUTMParamNames, getAllUTMProps, getUTMParamHeader } from './utils/utm';
/**
 * 自动链路追踪参数收集
 * @param sensors 神策埋点对象
 * @param needAutoTrack 是否需要设置全埋点，鉴于by-sensors和自定义接入一般都有全埋点，这里默认不设置
 */

export var autoUTMRegister = function autoUTMRegister(sensors) {
  var _sensors$register;

  var needAutoTrack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // 这个url进来带来的参数
  var theUTMProps = getAllUTMProps();
  var versionKey = '_a_u_v'; // 增加 auto utm的版本 便于追踪和验证，每次加载都重新注册版本字段，避免不一致的问题

  sensors === null || sensors === void 0 ? void 0 : (_sensors$register = sensors.register) === null || _sensors$register === void 0 ? void 0 : _sensors$register.call(sensors, _defineProperty({}, versionKey, '0.0.6')); // 这个url进来带了UTM参数，就先把前面注册的清掉

  if (Object.keys(theUTMProps).length > 0) {
    var _sensors$register2;

    sensors === null || sensors === void 0 ? void 0 : sensors.clearAllRegister(getAllUTMParamNames()); // 这个会往神策cookie sensorsdata2015jssdkcross 里面增加字段
    // 属于特殊的兼容处理方法，避免如下问题：
    // - 一方面是避免用自定义渠道的方式，字段名会被神策变更（我们不想被变更）的问题，同时也会增加数据量
    // - 另一方面 避免定义页面级的全局属性 sensors.registerPage 而没有cookie信息导致数据无法兼容cookie的渠道，到下一个页面就丢了的问题

    sensors === null || sensors === void 0 ? void 0 : (_sensors$register2 = sensors.register) === null || _sensors$register2 === void 0 ? void 0 : _sensors$register2.call(sensors, _objectSpread({}, theUTMProps));
  }

  if (needAutoTrack) {
    var _sensors$quick;

    sensors === null || sensors === void 0 ? void 0 : (_sensors$quick = sensors.quick) === null || _sensors$quick === void 0 ? void 0 : _sensors$quick.call(sensors, 'autoTrack'); // $pageview 事件 也就是全埋点 上面的autoUTM 依赖于这个
  }
};